export { useAnalytics } from './useAnalytics';

export const ANALYTICS_CHANNEL = 'embeddedConfluence';
